import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import EquipmentIntakeForm from './EquipmentIntakeForm';
import CommercialAutoForm from './CommercialAutoForm';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          {/* Equipment Insurance Form */}
          <Route path="/" element={<EquipmentIntakeForm />} />
          <Route path="/equipment" element={<EquipmentIntakeForm />} />

          {/* Commercial Auto Insurance Form */}
          <Route path="/auto" element={<CommercialAutoForm />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
